import { AceCard } from '../AceCard';
import { CollateralCardToolbar } from './CollateralCardToolbar';
import { useCollateralForm } from '../../forms/collateral/form';
import classes from './CollateralCard.module.css';
import { RealEstateCard } from './RealEstateCard';
import { useCollateralFormStore } from '../../forms/collateral/store';
import { useCollateralFormDefaultValues } from '../../forms/collateral/defaultValues';

interface CollateralCardProps {
  applicationID: string;
}

export const CollateralCard: React.FC<CollateralCardProps> = ({
  applicationID,
}) => {
  const { localOnly } = useCollateralFormStore(applicationID);
  const { estates } = useCollateralFormDefaultValues(applicationID);
  useCollateralForm(applicationID); // Required to initialize the form

  const ids = [...new Set(Object.keys(estates)), ...localOnly];

  return (
    <AceCard
      id={`Collateral.${applicationID}`}
      title="Collateral"
      noBorder
      noContentPadding
      isExpandedByDefault={false}
    >
      <div className={classes.rootContainer}>
        <CollateralCardToolbar applicationID={applicationID} />
        <div className={classes.collateralsContainer}>
          {ids.map((id) => (
            <RealEstateCard
              key={id}
              estateID={id}
              applicationID={applicationID}
            />
          ))}
        </div>
      </div>
    </AceCard>
  );
};
